<template>
  <div>
    <!-- <Navbar /> -->
    <!-- <div class="d-flex" id="wrapper"> -->
    <div class="d-flex" id="wrapper">
      <!-- <div class="bg-light border-right" id="sidebar-wrapper">
          <Sidebar active="Antrian"/>
      </div> -->
      <div class="container-fluid">
        <div v-if="loaded">
          <center class="pt-5 pb-3" v-if="processed">
            <h3 class="mb-4">Nomor antrian Anda adalah:</h3>
            <div class="row mb-4">
              <div class="col-md-4 offset-md-4 px-5">
                <div class="card p-2">
                  <h1 class="my-3 text-secondary">
                    {{
                      queue && queue.antrian_diambil
                        ? queue.antrian_diambil.nomor
                        : "Antrian diambil"
                    }}
                  </h1>
                </div>
              </div>
            </div>
            <div class="no-print">
              <h4 class="font-body text-muted mb-2">
                Saat ini antrian berada pada urutan
                <strong class="text-primary">{{
                  queue && queue.antrian_diproses
                    ? queue.antrian_diproses.nomor
                    : "Antrian diproses"
                }}</strong>
              </h4>
              <p>
                Silakan ambil nomor antrian Anda yang telah dicetak dan menuju
                ke meja pendaftaran
              </p>
              <div class="row">
                <div class="col-md-8 offset-md-2">
                  <div class="row mb-3">
                    <div class="col-md-12">
                      <div class="card p-3">
                        <p class="mb-0">
                          Jika Anda adalah pasien baru, Anda dapat melakukan
                          pengisian data pasien secara mandiri melalui komputer
                          'DAFTAR MANDIRI' yang ada di dekat meja pendaftaran.
                          Silakan hubungi petugas kami untuk membantu Anda
                          melakukan pendaftaran secara mandiri
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <p class="text-muted">Menutup secara otomatis dalam:</p>
              <h2 class="counter mt-2 mb-4">{{ counter }}</h2>
              <button
                onclick="window.print()"
                class="btn btn-outline-secondary btn-lg mr-2"
              >
                CETAK ULANG NOMOR ANTRIAN
              </button>
              <button @click="reset" class="btn btn-primary btn-lg">
                SELESAI
              </button>
            </div>
          </center>

          <center class="py-5" v-else>
            <img
              src="/img/logo.png"
              alt="Logo SIMRS"
              style="height: 1.75rem; object-fit: contain; width: auto"
            />
            <h2 class="mt-5 mb-2">Selamat Datang</h2>
            <h4 class="font-body text-muted mb-5">
              Silakan ambil nomor antrian Anda!
            </h4>
            <div class="row">
              <div class="col-md-8 offset-md-2">
                <div class="row">
                  <div class="col-md-4 px-4">
                    <button
                      @click="() => processQueue(1)"
                      to="/antrian/selesai"
                      class="card card-antrian py-4 px-3 w-100"
                    >
                      <h1 class="mt-4">
                        <i class="material-symbols-outlined text-primary"
                          >accessibility</i
                        >
                      </h1>
                      <h4 class="mb-4">Pasien Umum</h4>
                    </button>
                  </div>
                  <div class="col-md-4 px-4">
                    <button
                      @click="() => processQueue(2)"
                      to="/antrian/selesai"
                      class="card card-antrian py-4 px-3 w-100"
                    >
                      <h1 class="mt-4">
                        <i class="material-symbols-outlined text-secondary"
                          >credit_card</i
                        >
                      </h1>
                      <h4 class="mb-4">Pasien BPJS</h4>
                    </button>
                  </div>
                  <div class="col-md-4 px-4">
                    <button
                      @click="() => processQueue(3)"
                      to="/antrian/selesai"
                      class="card card-antrian py-4 px-3 w-100"
                    >
                      <h1 class="mt-4">
                        <i class="material-symbols-outlined text-warning"
                          >verified_user</i
                        >
                      </h1>
                      <h4 class="mb-4">Pasien Asuransi</h4>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </center>
        </div>
        <Loading v-else></Loading>
      </div>
    </div>
  </div>
</template>
<style scoped>
h1 > i {
  font-size: 2.5rem;
}
.w-100 {
  width: 100% !important;
}
</style>
<script>
// @ is an alias to /src
// import Navbar from '@/components/Navbar.vue'
// import Sidebar from '@/components/Sidebar.vue'
import Loading from "@/components/Loading.vue";
// import { HTTP_ENC } from "@/config.js";
export default {
  name: "AntrianPasien",
  components: {
    Loading,
  },
  data: () => {
    return {
      counter: 30,
      countProcess: null,
      processed: false,
      queue: null,
      errors: [],
      loaded: true,
      countdown: null,
      synth: window.speechSynthesis,
      voiceList: [],
      greetingSpeech: new window.SpeechSynthesisUtterance(),
    };
  },
  methods: {
    processQueue: async function(id_asuransi) {
      this.loaded = false;

      try {
        let result = await this.$store.state.HTTP_ENC.post(
          `antrian`,
          `id_asuransi=${id_asuransi}`
        );
        //console.log(result);
        if (result.status == "200") {
          this.queue = result.data;
          this.greetingSpeech.text = `Nomor Antrian Anda Adalah ${this.queue.antrian_diambil.nomor}. Silakan cetak nomor antrian Anda, lalu menunggu di depan loket ${this.queue.antrian_diambil.tempat_proses}.`;
          //   56 adalah bahasa indonesia
          //   6 adalah bahasa indonesia
          //   41 adalah bahasa inggris
          //   versi lain:
          //   11 adalah bahasa indonesia
          this.greetingSpeech.voice = this.voiceList[11];
          this.synth.speak(this.greetingSpeech);
        } else {
          this.errors.push(result.status);
        }
        this.processed = true;
        this.loaded = true;
        this.countDown();
      } catch (e) {
        //console.log(e);
        this.errors.push(e);
      }
    },
    countDown: async function() {
      setTimeout(function() {
        window.print();
      }, 1000);
      let self = this;
      this.countProcess = setInterval(function() {
        if (self.counter > 0) {
          self.counter -= 1;
        } else {
          clearInterval(self.countProcess);
          self.countProcess = null;
          self.reset();
        }
      }, 1000);
    },
    reset: async function() {
      if (this.countProcess) {
        clearInterval(this.countProcess);
      }
      this.counter = 30;
      this.processed = false;
      // location.reload();
      // window.location.href='';
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    this.voiceList = this.synth.getVoices();
    this.synth.onvoiceschanged = () => {
      this.voiceList = this.synth.getVoices();
    };
  },
};
</script>
